import { fetchBeaconsStore, fetchBeaconStoreById, fetchBeaconsTypes, fetchBeaconTypeById, SearchBeaconsStores, updateBeacons } from "@/apiCalls/apiCalls";
import { useDebounce } from "@/utils/DebounceHook";
import { errorNotification, successNotification } from "@/utils/Notification";
import { Col, Drawer, Input, Row, Select, Form, Spin } from "antd";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { LoadingOutlined } from "@ant-design/icons";
import axios from "@/apiCalls/axios";
import FormData from "form-data";
import * as XLSX from 'xlsx';
import { useLocation, useNavigate } from "react-router-dom";
import useAxiosPrivate from "@/context/UseAxiosPrivate";
import useAxiosPrivateFile from "@/context/UseAxiosPrivateFileUploads"
import { Avatar, Divider, List, Skeleton } from 'antd';
import InfiniteScroll from 'react-infinite-scroll-component';
import { exportFailedUploadBeaconsToExcel } from "@/utils/ExcelDataExport";
import { ArrowDownTrayIcon } from "@heroicons/react/24/outline";
import { Button } from "@/components/ui/button";


const { Option } = Select
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
interface AssetDrawerProps {
    updateExcelDrawer: boolean;
    setUpdateExcelDrawer: React.Dispatch<React.SetStateAction<boolean>>;

}

const UploadExcelDrawerr: React.FC = () => {
    const [file, setFile] = useState<any>(null);
    const [loading, setLoading] = useState(false);
    const fileInputRef: any = useRef(null);
    const [alerts, setAlerts] = useState([]);
    const navigate = useNavigate()
    const location = useLocation()
    const axiosPrivate = useAxiosPrivate()
    const axiosPrivateFile = useAxiosPrivateFile()
    const [failedata, setFailedData] = useState<any[]>([])

    const handleFileChange = (e: any) => {
        const selectedFile = e.target.files[0];
        if (selectedFile && selectedFile.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
            setFile(selectedFile);
        } else {
            alert('Please upload a valid Excel file (.xlsx)');
        }
    }
    
    const handleUpload = async () => {
        setFailedData([]);
        if (!file) return;
        const reader = new FileReader();
        reader.onload = async (e: any) => {
            const data = new Uint8Array(e.target.result)
            const workbook = XLSX.read(data, { type: 'array' })

            const sheetName = workbook.SheetNames[0]
            const worksheet = workbook.Sheets[sheetName]

            const jsonData: any = XLSX.utils.sheet_to_json(worksheet, { header: 1, blankrows: false });
            const maxColumns = Math.max(...jsonData.map((row: any[]) => row.length));

            const headerRow = jsonData[0];
            const uuidIndex = headerRow.indexOf('uuid');
            const tagNoIndex = headerRow.indexOf('tag_no');

            if (uuidIndex === -1 || tagNoIndex === -1) {
                alert("Error: The sheet must contain both 'uuid' and 'tag_no' columns.");
                return;
            }

            let missingDataFound = false;
            let invalidLengthFound = false;
            const uuidSet = new Set();
            const tagNoSet = new Set();
            let duplicateUuids: string[] = [];
            let duplicateTagNos: string[] = [];

            jsonData.forEach((row: any[], rowIndex: number) => {
                if (rowIndex === 0) return

                for (let colIndex = 0; colIndex < maxColumns; colIndex++) {
                    const cell = row[colIndex];
                    if (cell === null || cell === undefined || cell === '') {
                        missingDataFound = true;
                        console.warn(`Missing data in row ${rowIndex + 1}, column ${colIndex + 1}`);
                    }
                }

                const uuidValue = row[uuidIndex] ? String(row[uuidIndex]) : '';
                const tagNoValue = row[tagNoIndex] ? String(row[tagNoIndex]) : '';

                if (uuidValue && uuidValue.length !== 32) {
                    invalidLengthFound = true;
                    console.warn(`Invalid uuid length in row ${rowIndex + 1}: ${uuidValue}`);
                }

                if (tagNoValue && tagNoValue.length !== 40) {
                    invalidLengthFound = true;
                    console.warn(`Invalid tag_no length in row ${rowIndex + 1}: ${tagNoValue}`);
                }

                if (uuidSet.has(uuidValue)) {
                    duplicateUuids.push(uuidValue);
                } else {
                    uuidSet.add(uuidValue);
                }

                if (tagNoSet.has(tagNoValue)) {
                    duplicateTagNos.push(tagNoValue);
                } else {
                    tagNoSet.add(tagNoValue);
                }
            })

            if (missingDataFound) {
                alert(`Missing data found in one or more rows/columns!`);
                return;
            }

            if (invalidLengthFound) {
                alert(`One or more rows have 'uuid' or 'tag_no' values with incorrect lengths (uuid: 32 characters, tag_no: 40 characters).`);
                return;
            }


            if (duplicateUuids.length > 0 || duplicateTagNos.length > 0) {
                let duplicateMessage = '';
                if (duplicateUuids.length > 0) {
                    duplicateMessage += `Duplicate UUIDs found: ${duplicateUuids.join(', ')}.\n`;
                }
                if (duplicateTagNos.length > 0) {
                    duplicateMessage += `Duplicate Tag Nos found: ${duplicateTagNos.join(', ')}.`;
                }
                alert(duplicateMessage);
                return;
            }

            const formData = new FormData();
            formData.append('file', file);

            onFinish(formData);
        };

        reader.readAsArrayBuffer(file);
    };

    const getClientIPAndURL = async () => {
        try {

            const response = await axios.get('https://api.ipify.org?format=json');
            const clientIp = response.data.ip
            const currentUrl = window.location.href
            return { clientIp, currentUrl }
        } catch (error) {
            console.error('Error fetching IP address:', error);
            return { clientIp: 'Unknown', currentUrl: window.location.href }
        }
    }

    const onFinish = (formData: any) => {
        setLoading(true);
        let isMounted = true;
        const controller = new AbortController()
        getClientIPAndURL().then(({ clientIp, currentUrl }) => {
            return axiosPrivateFile.post('/api/v1/beacons/uploadFile', formData, {
                signal: controller.signal,
                headers: {
                    'X-Client-IP': clientIp,
                    'X-Origin-URL': currentUrl
                }
            })
        }).then((response: any) =>
            response.data
        ).then((data) => {
            if (isMounted) {
                successNotification(
                    "File uploaded successfully!",
                    "",
                    'topRight'
                )
                setFailedData(data)
                handleCancel()
            }
        }).catch((err: any) => {
            const errors = err?.response?.data?.errors;
            if (errors && errors?.[0]?.message === "token as expired") {
                let errror = errors?.[0]?.message
                errorNotification(
                    "There was an issue",
                    `${errror}`,
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            } else if (errors && Array.isArray(errors) && errors.length > 0) {
                errors.forEach((error: any) => {
                    const errorMessage = error.message || "An unknown error occurred";
                    errorNotification(
                        "There was an issue",
                        `${errorMessage}`,
                        'topRight'
                    )
                })
            } else {
                errorNotification(
                    "There was an issue",
                    "No server reponse",
                    'topRight'
                )
                navigate('/', { state: { from: location }, replace: true })
            }
        }).finally(() => {
            setLoading(false)
        })
        return () => {
            isMounted = false
            controller.abort()
        }
    }

    const handleCancel = () => {
        setFile(null)
        setLoading(false)
        if (fileInputRef.current) {
            fileInputRef.current.value = null
        }
    }
    const loadData = () => {}

    return (
        <>
            <div className="flex flex-col items-start space-y-4">
                <Button
                    variant="outline"
                    className="text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                    onClick={(() => exportFailedUploadBeaconsToExcel(failedata, "EezyTrackBeaconUploadTemplate"))}
                >
                    <ArrowDownTrayIcon className="h-5 w-5" />
                    <span> Upload Template</span>
                </Button>
                <label className="block">
                    <span className="sr-only">Upload Excel File</span>
                    <input
                        type="file"
                        accept=".xlsx"
                        ref={fileInputRef}
                        onChange={handleFileChange}
                        className="text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                    />
                </label>

                {file && (
                    <div className="flex items-center space-x-4">
                        {loading ? (
                            <div className="flex items-center space-x-2">
                                <span className="text-blue-500 animate-pulse">Uploading...</span>
                                <button
                                    onClick={handleCancel}
                                    className="text-red-500 hover:text-red-700 font-bold text-lg"
                                >
                                    X
                                </button>
                            </div>
                        ) : (
                            <div className="flex items-center space-x-2">
                                <span className="text-green-500">{file.name}</span>
                                <button
                                    onClick={handleUpload}
                                    className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                                >
                                    Upload
                                </button>
                                <button
                                    onClick={handleCancel}
                                    className="text-red-500 hover:text-red-700 font-bold text-lg"
                                >
                                    X
                                </button>
                            </div>
                        )}
                    </div>
                )}
            </div>
            <div>
                {failedata.length > 0 && (
                    <Button
                        variant="outline"
                        className="ml-auto flex items-center space-x-2"
                        onClick={(() => exportFailedUploadBeaconsToExcel(failedata, "EezyTrackfailedUploadData"))}
                    >

                        <ArrowDownTrayIcon className="h-5 w-5" />
                        <span>Export</span>
                    </Button>
                )}
                {failedata.length > 0 && (
                    <InfiniteScroll
                        dataLength={failedata?.length ? failedata.length : 0}
                        next={loadData}
                        hasMore={failedata?.length < 0 ? failedata?.length < 0 : false}
                        loader={<Skeleton avatar paragraph={{ rows: 1 }} active />}
                        endMessage={<Divider plain>{`🤐 Total failed  beacon(s) ${failedata?.length}`}</Divider>}
                        scrollableTarget="scrollableDiv"
                    >
                        <List
                            dataSource={failedata}
                            renderItem={(item) => (
                                <List.Item key={item.cid}>
                                    <List.Item.Meta
                                        avatar={""}
                                        title={item.cid !== 'NONE' ? item.cid : ''}
                                    // description={item.tag_no}
                                    />
                                    {/* <div>Content</div> */}
                                </List.Item>
                            )}
                        />
                    </InfiniteScroll>
                )}

            </div>

        </>
    )
}

export default UploadExcelDrawerr